import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { discountOptions } from "../../../utils/discountOptions";

export const OemColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const logData = JSON.parse(sessionStorage.getItem("userData"));
  const isSystemUser = [1, 2, 3].includes(logData?.role_value);

  return [
    {
      title: "No",
      dataIndex: "OemNo",
      key: "OemNo",
      hidden: !isSystemUser,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Name",
      dataIndex: "OemName",
      key: "OemName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Description",
      dataIndex: "OemDesc",
      key: "OemDesc",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Domain",
      dataIndex: "Domain",
      key: "Domain",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Domain"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Domain",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    ...(logData?.role_value === 1
      ? [
          {
            title: "Max Account",
            dataIndex: "MaxAccount",
            key: "MaxAccount",
            sorter: (a, b) => () => {},
            sortIcon: () => (
              <SortIcon
                sortOrder={modParams.order}
                columnKey="MaxAccount"
                sortBy={modParams.sort_by}
              />
            ),
            onHeaderCell: () => ({
              onClick: () =>
                setParams((prev) => ({
                  ...modParams,
                  sort_by: "MaxAccount",
                  order: modParams.order === "desc" ? "asc" : "desc",
                })),
            }),
          },
        ]
      : []),
    // {
    //   title: "Discount",
    //   dataIndex: "Discount",
    //   key: "Discount",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="Discount"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "Discount",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    //   render: (text) => {
    //     const matchedValue = discountOptions.find(
    //       (item) => item.value === text
    //     )?.label;
    //     return <>{matchedValue}</>;
    //   },
    // },

    // {
    //   title: "License",
    //   dataIndex: "License",
    //   key: "License",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="LicenseNo"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "LicenseNo",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Group",
      dataIndex: "GroupName",
      key: "GroupName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="GroupNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "GroupNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Cloud Site",
      dataIndex: "CloudSite",
      key: "CloudSite",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="CloudSite"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "CloudSite",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (_, record) => {
        return record.CloudSite === 0
          ? "No"
          : record.CloudSite === 1
            ? "Yes"
            : null;
      },
    },
    {
      title: "On Site Register",
      dataIndex: "OnSiteRegister",
      key: "OnSiteRegister",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OnSiteRegister"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OnSiteRegister",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (_, record) => {
        return record.OnSiteRegister === 0
          ? "No"
          : record.OnSiteRegister === 1
            ? "Yes"
            : null;
      },
    },
    {
      title: "OEM Info",
      dataIndex: "OemInfo",
      key: "OemInfo",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemInfoNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemInfoNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
                  <Link
                    to={`/oem/edit/${record?.OemNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.OemNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
